import * as React from 'react'
import client from '../../../client'
import reportHistoryTable from './ReportHistoryTable'
import { TimeFrameDimensionOptionType } from '../types'

import usePromise from '../../../hooks/usePromise'

export interface ReportHistoryProps {
  reportType: string
  timeFrameDimensionOptions?: TimeFrameDimensionOptionType[]
  reportsCount?: number
}

const ReportHistory: React.FunctionComponent<ReportHistoryProps> = props => {
  const [loading, result, error, refresh] = usePromise(() => client.reportHistory(props.reportType))

  const [firstFetchComplete, setFirstFetchComplete] = React.useState(false)
  const [reports, setReports] = React.useState([])

  React.useEffect(() => {
    if (result !== null) {
      let returnedReports = result.data.reports
      if (props.reportsCount) {
        returnedReports = returnedReports.slice(0, props.reportsCount)
      }
      setReports(returnedReports)

      if (!firstFetchComplete) {
        setFirstFetchComplete(true)
      }
    }
  }, [result, props.reportsCount, firstFetchComplete])

  React.useEffect(() => {
    const poller = setInterval(refresh, 3000)
    return () => {
      if (poller) window.clearInterval(poller)
    }
  }, [refresh])

  return (
    <div style={{ marginTop: 10, marginBottom: 0 }}>
      <h3>Past reports</h3>
      {reportHistoryTable(loading && !firstFetchComplete, reports || [], error, props.timeFrameDimensionOptions)}
    </div>
  )
}

export default ReportHistory
